/** 广告平台：label 展示用，value 调接口筛选必传英文 */
export const ADN_PLATFORMS = [
  { value: 'sigmob', label: 'Sigmob', aliases: ['Sigmob'] },
  { value: 'gdt', label: '优量汇', aliases: ['GDT'] },
  { value: 'kuaishou', label: '快手', aliases: ['ks', 'KuaiShou', 'Kuaishou'] },
  { value: 'baidu', label: '百度', aliases: ['Baidu'] },
  { value: 'gromore', label: 'Gromore', aliases: ['GroMore'] },
  { value: 'beizi', label: 'Beizi', aliases: [] },
  { value: 'pangle', label: '穿山甲', aliases: ['Pangle'] },
  { value: 'octopus', label: 'Octopus', aliases: [] },
  { value: 'Tobid_adx', label: 'ToBid ADX', aliases: ['tobid_adx', 'ToBid ADX', 'ToBid_ADX'] },
]

const adnLookup = ADN_PLATFORMS.reduce((map, platform) => {
  map[platform.value.toLowerCase()] = platform
  platform.aliases.forEach((alias) => {
    map[alias.toLowerCase()] = platform
  })
  return map
}, {})

/** 将接口/历史数据中的 adnName 转为展示用 label */
export function resolveAdnLabel(adnName) {
  if (!adnName) return '-'
  const platform = adnLookup[String(adnName).toLowerCase()]
  return platform ? platform.label : adnName
}

/** 判断记录 adnName 是否属于指定平台（含 aliases） */
export function matchAdnName(recordAdnName, platformValue) {
  if (!recordAdnName || !platformValue) return false
  const platform = adnLookup[platformValue.toLowerCase()]
  if (!platform) return recordAdnName === platformValue
  const normalized = String(recordAdnName).toLowerCase()
  if (normalized === platform.value.toLowerCase()) return true
  return platform.aliases.some((alias) => alias.toLowerCase() === normalized)
}
